// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as PartnerStore$PorterinFeature from "../../domain/repo/store/PartnerStore.mjs";
import * as PartnersFormAckModuleScss from "../styles/PartnersFormAck.module.scss";

var styles = PartnersFormAckModuleScss;

function PartnersFormAckCmp(Props) {
  var name = Props.name;
  var resetFunc = Props.resetFunc;
  return React.createElement("div", {
              className: styles["modal-container-ack"] + " " + styles["flex-col-align-center"]
            }, React.createElement("div", {
                  className: styles.ack + " " + styles.msg
                }, PartnerStore$PorterinFeature.ack_msg), React.createElement("div", {
                  className: styles.ack + " " + styles.name
                }, name), React.createElement("div", {
                  className: styles.ack + " " + styles.desc
                }, PartnerStore$PorterinFeature.ack_desc), React.createElement("div", {
                  className: styles["bold-txt-btn"] + " " + styles["request-button"],
                  onClick: (function (_e) {
                      Curry._1(resetFunc, undefined);
                    })
                }, PartnerStore$PorterinFeature.req_msg));
}

var make = PartnersFormAckCmp;

var $$default = PartnersFormAckCmp;

export {
  styles ,
  make ,
  $$default ,
  $$default as default,
}
/* styles Not a pure module */
